import $ from 'jquery';
import Masonry from 'masonry-layout';
// eslint-disable-next-line no-unused-vars
import imagesLoaded from 'imagesloaded';

Drupal.behaviors.thrilledMasonry = {
  attach: function (context) {

    $( window ).on( 'load', function() {
      $('.grid').imagesLoaded()
        .always( function( instance ) {
          const grid = document.querySelector('.grid', context);

          if (grid) {
            let msnry = new Masonry(
              grid,
              {
                itemSelector: '.grid-item',
                percentPosition: true,
                horizontalOrder: true,
                columnWidth: '.grid-sizer',
              }
            );
          }
        });
    });
  }
};
